'use client';
import { Tooltip } from './Tooltip.js';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import React from 'react';

const Info = ({ text, style }) => {
    return (React.createElement(Tooltip, { delayDuration: 300, content: text },
        React.createElement(InfoCircledIcon, { style: Object.assign({ transformOrigin: 'center', width: 'max-content', display: 'flex-inline', justifyContent: 'center', alignItems: 'center', verticalAlign: 'middle' }, style) })));
};

export { Info };
